import calendarIcon from "../../assets/calendar-2.svg";
import greentick from "../../assets/righttick.svg";
import arrowleft from "../../assets/arrowleft.png";
import profilering from "../../assets/profilering.png";
import face from "../../assets/profile.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import summarizedpng from '../../assets/summarized.png'
import checkmark from '../../assets/checkmark.png';
import { DateTime } from 'luxon';
import MainHeader from "header/header";
import api from "../../api/api";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { formatDate } from "utils/date";
import doc from '../../assets/doc.png'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DescriptionIcon from '@mui/icons-material/Description';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import { formatDateToYMD } from "utils/date";
import { decodeTimeToISO } from "utils/date";
import { NavigateNext } from "@mui/icons-material";
import DatePicker from "../../version2/utils/singledatepicker";
// import PdfRender from "./pdfrender";
import ToastMessage from "utils/muialerts/righttoptoast";
import Ring from "pages/landing/ring";
import SimpleModal from "alerts/recordingscreen/simplemodal";
import { FaInfoCircle } from "react-icons/fa";
import PdfRender from "pages/recording/pdfrender";
import BasicPdfRender from "basic/basicutils/basicpdfrender";
import PromptModal from "alerts/recordingscreen/promptmodal";
import useModalStore from "zustand/zustandstore";
import SideBarWrapper from "version2/sidebarwrap";
import V2header from "version2/v2header";
import { formatDatev2 } from "utils/date";
import { faCalendar, faPlay, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AudioModal from "basic/modals/audiomodal";
import { convertToddmmyyy } from "utils/date";
import backarraow from '../../assets/backarraow.png'
import DeleteRecord from "version2/modals/deleterecord";
const BasicArchive = () => {
  const [isRecording, setIsRecording] = useState(false);
  const mydata = useModalStore();
  const [sortedData, setSortedData] = useState([]);
  const location = useLocation();
  const { ts,profile_photo,back } = location.state || {};
  const navigate = useNavigate();
   const [promptmodal,setPromptModal]=useState(false)
  const[showinfo,setShowInfo]=useState(false)
  const[currentobj,setcurrentobj]=useState({})
  const [data, setData] = useState([]);
  const[deletemodal,setDeletemodal]=useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [audioSrc, setAudioSrc] = useState(null);
  const [loading,setLoading]=useState(false)
  const [today, setToday] = useState("");
   const { setModalValue } = useModalStore()
  const [isPickerOpen, setIsPickerOpen] = useState(false); // State to toggle DatePickerWithSlider
  const [datestate, setDateState] = useState([
    {
      startDate: new Date(), 
      endDate: new Date(), 
      key: "selection"
    },
  ]);
  useEffect(() => {
    if (mydata.selectedRecord?.ts) {
      const formattedDate = new Date(mydata.selectedRecord.ts);
      setDateState([
        {
          startDate: formattedDate,
          endDate: formattedDate,
          key: "selection",
        },
      ]);
      fetchdata(formattedDate)
    }
  }, [mydata.selectedRecord?.ts]);
  const percentage=100
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };

  const [pdffile,setPdffile]=useState()
  const [value, setValue] = useState([420, 1140]); // Example: 10:00 AM to 12:00 PM
  const [showdate, setShowdate] = useState("");
  const [ispdfshow,setIspdfShow]=useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const[mycard,setMyCard]=useState('')
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const[clicked,setClicked]=useState({})
  const [severity, setSeverity] = useState('success');
  const [elapsedTime, setElapsedTime] = useState(0);
  const[myimgurl,setMyimgUrl]=useState(false)
  function checkImage(url) {
    const img = new Image();
    img.onload = function() {
        console.log("Image loaded successfully");
        setMyimgUrl(true)
    };
    img.onerror = function() {
        console.log("Failed to load image");
        setMyimgUrl(false)
    };
    img.src = url;
  }
const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setOpen(false);
};
const handleCloseModal = () => {
  setIsModalOpen(false);
  setAudioSrc(null); // Reset audio source when modal closes
};
useEffect(() => {
  let interval = null;
  if (data.some((item) => item.transcriptionstatus === "Processing")) {
    interval = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
  } else {
    setElapsedTime(0);
  }
  return () => {
    if (interval) clearInterval(interval);
  };
}, [data]);
  const handleDeleteRecord = async () => {
    setDeletemodal(false)
    try {
      
      setIsLoading(true);
      const response = await api.delete('/v1/recording/delete', {
        data: {
          rowid:clicked?.id, // Sending the payload with rowid
        },
      });
      // setModalValue({trigger:true})
      if(response.status==200){
        setMessage('Record Has Been Deleted')
      setOpen(true) 
      }else{
        setMessage(response?.message)
        setOpen(true) 
      }
      

    } catch (error) {
      console.error('Error deleting record:', error);
    } finally {
      setIsLoading(false);
      fetchdata()
    }
  };
const renderStatus = (item) => {
 

  // Render progress or status based on transcription status
  if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
    return "Ready";
  } else if (item.transcriptionstatus === "Submitted") {
    return <Ring value={20} />;
  } else if (item.transcriptionstatus === "Processing") {
    const recording_duration = item.recording_duration || 200; // Fallback to a default value
    const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
  
  const recordingStartTime = DateTime.fromISO(item.ts).toSeconds();
// Current time in UTC, rounded to whole seconds
const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding

    const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);

    // Calculate the initial percentage based on the elapsed time
    const completionPercentage = Math.min(
      Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
      90
    );

return <Ring value={completionPercentage} />;

  } else if (item.transcriptionstatus === "Summarized") {
    return (
      <div className="ml-2">
        <Tooltip title="Pending Review">
          <img  src={summarizedpng} alt="pending review" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else if (item.transcriptionstatus === "APPROVED") {
    return (
      <div className="ml-2">
        <Tooltip title="Completed">
          <img src={checkmark} alt="Completed" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}
  useEffect(() => {
    const date = new Date(ts); // Convert to a JavaScript Date object
    // Format the date as: "Monday, September 23, 2024"
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    setShowdate(formattedDate);
  }, [ts]);
  const { id } = useParams();
  const handlepdf = async (value,card) => {

    if(card.transcriptionstatus=='Processing'){
      setMessage('Update in process. Hold on!');
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return
    }

    try {
      // Trigger loading spinner
      setIsLoading(true);

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()

    // Fetch the PDF from the server with a unique parameter to prevent caching
    const response = await api.get(`/v1/basic/documents/PDF/${value}?_=${uniqueParam}`, {
      responseType: "blob", // Ensure response type is 'blob' for binary data
    });
       const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
      setIsLoading(false);
      setIspdfShow(true)
    }
  };

  let payload = {
    filter_array: {
      date_filter: {
        start_date:formatDateToYMD(datestate[0].startDate),
        end_date:formatDateToYMD(datestate[0].endDate),
        startTime: decodeTimeToISO(value[0]),
        endTime: decodeTimeToISO(value[1]),
      },
    },
    "time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone
  };

  const fetchdata = async (a) => {
    setIsLoading(true);
if(a){
  payload.filter_array.date_filter.start_date=formatDateToYMD(a)
  payload.filter_array.date_filter.end_date=formatDateToYMD(a)
}
    try {
      let response = await api.post(`/v1/basic/patient/${id}/recording/details`,payload
      );    
      if (response.status == 200) {
           setData(response?.data);
      }else{
        setData([])
    //     setModalValue({ screen :0}) 
    //     setModalValue({selectedRecord:{}})
    //  navigate('/v2')
      } 
    
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const Loaddata = async (x) => {

    try {
      let response = await api.post(`/v1/basic/patient/${id}/recording/details`,x
      );    
      if (response.status == 200) {
           setData(response?.data||[]);
      }else{
        setData([])
      }
    
    } catch (error) {
      console.log(error);
    } finally {
    
    }
  };
   const handleplay=async(audio_link)=>{
    try {
      setLoading(true)
      const response = await api.get(`/v1/audio/${audio_link}`, {
        responseType: "blob", // Make sure response is treated as a Blob
      });
      const fileBlob = response;
      const audioURL = URL.createObjectURL(fileBlob);
          setAudioSrc(audioURL);
          if(fileBlob&&fileBlob.size==0){
         setAudioSrc('')
         alert('')
          }
        setIsModalOpen(true)
    } catch (error) {
      console.log(error)
    }finally{
  setLoading(false)
    }
   }
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (data.length > 0) {
  //       // Check if all items are "APPROVED"
  //       const allApproved = data.every(item => item.transcriptionstatus!=='Processing');

  //       if (allApproved) {
  //         clearInterval(interval); // Stop polling if all items are approved
  //         console.log('All items are approved.');
  //       } else {
  //         Loaddata(); // Continue calling the API if not all are approved
  //       }
  //     } else {
  //       Loaddata(); // Fetch data initially if the array is empty
  //     }
  //   }, 2000);

  //   return () => clearInterval(interval); // Cleanup interval on component unmount
  // }, [data,datestate]); 


  useEffect(() => {
    const interval = setInterval(() => {
      const updatedPayload = {
        filter_array: {
          date_filter: {
            startTime: decodeTimeToISO(value[0]),
            endTime: decodeTimeToISO(value[1]),
            start_date: formatDateToYMD(datestate[0].startDate),
            end_date: formatDateToYMD(datestate[0].endDate),
          },
        },
        "time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone
      };
      Loaddata(updatedPayload);
    }, 4000); // 2000ms = 2 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [id,location.pathname,datestate]);

  useEffect(() => {
    // const timestamp = new Date(ts);
    // const yy_mm_dd = timestamp.toISOString().slice(2, 10).replace(/-/g, "-");
   // payload.start_date = yy_mm_dd;
    fetchdata();
    checkImage(profile_photo)
  }, [location]);

  const toggleDatePicker = () => {
    !isPickerOpen && setIsPickerOpen(true);
  };
  useEffect(() => {
    const sorted = [...data].sort((a, b) => new Date(a.ts) - new Date(b.ts));
    setSortedData(data);
  }, [data]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4; // Number of items to display per page

  const indexOfLastData = currentPage * itemsPerPage; // Last index of current page
  const indexOfFirstData = indexOfLastData - itemsPerPage; // First index of current page
  const currentData = sortedData.slice(indexOfFirstData, indexOfLastData); // Get current page data
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleDateChange = (newRange) => {
    setDateState(newRange);
  };
   const handledateclose = () => {
      const { startDate, endDate } = datestate [0];
  
      // Check if startDate and endDate are not the same
      // if (startDate.getTime() !== endDate.getTime()) {
      //   payload.filter_array.date_filter.end_date = formatDateToYMD(
      //     datestate[0].endDate
      //   );
        
      // } else {
      //   delete payload.filter_array.date_filter.end_date;
      // }
      payload.filter_array.date_filter.end_date = formatDateToYMD(
        datestate[0].endDate
      );
      payload.filter_array.date_filter.start_date = formatDateToYMD(
        datestate[0].startDate
      );
      payload.filter_array.date_filter.startTime = decodeTimeToISO(value[0]);
      payload.filter_array.date_filter.endTime = decodeTimeToISO(value[1]);
  
      fetchdata();
      setIsPickerOpen(!true);
    };
  return (
    <>
<div className="div  flex-col justify-start">
    <V2header/>
    <div className='flex relative w-full gap-8  items-start p-4 h-auto'>
      <div>

        
      </div>
<img
onClick={()=>{
  if(back){
    setModalValue({ screen: 0 })
    navigate(-1)
  }else{
    navigate(-1)
  }}
  }
src={backarraow} alt=""  className='w-5 h-5  cursor-pointer' />
<div className="flex gap-4">
 {mydata.selectedRecord?<><div>
          <div
  className="relative flex justify-center items-center w-[83px] h-[83px] rounded-full ml-4"
  style={circleStyle}
>
  <div className="flex justify-center items-center w-[70px] h-[70px] bg-[#FAFAF9] rounded-full">
    <img
      src={'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
      alt="profile"
      className="flex justify-center items-center w-[60px] h-[60px] bg-[#C4C4C4] rounded-full"
    />
  </div>
</div>  
        </div>
        <div className="text-start font-sans  font-normal">
  {mydata.selectedRecord?.patient_name ||mydata.selectedRecord?.patientid ? (<>
    <div className="text-xxl flex items-center gap-4 sm:text-2xl text-gray-600">
      {mydata.selectedRecord?.patient_name} 
    </div>
    <div className="text-xxl text-gray-600">
    {mydata.selectedRecord?.patientid ? `${mydata.selectedRecord?.patientid}` : ''}
    </div>
    {/* <div className="text-xxl text-gray-600">
    {convertToddmmyyy(mydata.selectedRecord?.ts)}
    </div> */}
 </>) : null}
</div></>:<></>}

</div>
    

  </div>


      <div
          className={`flex ${
          isPickerOpen ? " md:items-start sm:min-h-[100vh]" : "items-center"
        } items-center mt-8 justify-center w-full  sm:h-auto md:h-auto`}
      >
        <div className="w-[95%] md:w-[45%]  h-min-[40px] h-auto md:mt-10   p-6  bg-white rounded-[20px] shadow-[0px_2px_13px_#00000040]">
          {/* <div className="flex items-start ">
            <img
              onClick={() => {
                navigate(-1);
              
              }}
              src={arrowleft}
              alt="Down Arrow"
              className="w-5 h-5 cursor-pointer"
            />
          </div> */}
          {/* <div className="relative flex items-center justify-center mr-4">
  {myimgurl ? (
    <>
      <img src={profile_photo} 
      className={`${isRecording ? "w-[60px] h-[60px]" : "w-[100px] h-[95px]"} rounded-full`}
      alt="Profile" />
    </>
  ) : (
    <>
      <img
        src={profilering}
        alt="Profilering"
        className={`${isRecording ? "w-[60px] h-[60px]" : "w-[90px] h-[85px]"}`}
      />
      <img
        src={face}
        alt="Face"
        className={`absolute ${isRecording ? "w-[40px] h-[60px]" : "w-[59px] h-[80px]"}`}
      />
    </>
  )}
</div> */}

<div className="w-full flex items-center relative mt-2">
  <div className="absolute left-1/2 transform -translate-x-1/2 font-semibold text-[#000000] text-[20px] tracking-[0] leading-[normal] whitespace-nowrap cursor-pointer">
    Archive
  </div>
  <FontAwesomeIcon     onClick={toggleDatePicker} icon={faCalendar} className="ml-auto cursor-pointer" />
  
  {isPickerOpen && (
                <div className="absolute md:top-6 top-8 right-[-25px]  z-20 sm:top-6 sm:right-[-450%] md:right-0 ">
                    <DatePicker
                      handleDateClose={handledateclose}
                      datestate={datestate}
                      handledateChange={handleDateChange}
                      value={value}
                      setValue={setValue}
                      setIsPickerOpen={setIsPickerOpen}
                    />
                  </div>
                )}
             
</div>


        
          <div
            className="w-max-lg custom-scrollbar gap-4 flex flex-col  justify-center items-center px-2"
            style={{
              height: "370px", // Set the desired height for the scroll area
              overflowY: "auto", // Enable vertical scrolling when content exceeds height
            }}
          >
         {currentData && currentData.length > 0 ? (
  currentData.map((card, index) => (
    <div
      key={index}
      onClick={() => {
        if (card.transcriptionstatus === 'Processing') {
          setMessage('Update in process. Hold on!');
          setSeverity('info'); // Change severity as needed
          setOpen(true);
          return;
        }else{
        handlepdf(card.audiolink.split(".")[0],card,)
        }
       
      }}
      className="flex items-center justify-between cursor-pointer p-6 bg-white shadow-md rounded-[10px] w-full h-16 "
      style={{ boxShadow: "0 1px 4px rgba(0, 0, 0, 0.25)" }}
    >
    

      <div className="flex items-center gap-4">
        <div className="flex w-10 h-10 rounded-full items-center justify-center bg-[#DBEAFE]">
          {/* <img
            src={doc}
            alt="Calendar Icon"
            className="w-5 h-5"
          /> */}
        <DescriptionIcon style={{color:"#2563EB"}}/>
        </div>
        <div
          style={{ cursor: "pointer" }}
          className="[font-family:'Poppins-Regular',Helvetica] text-left font-normal  text-[#1E293B] text-sm tracking-[0] leading-[normal]"
        >
          {formatDatev2(card.ts)}
        </div>
      </div>
      <div className="flex flex-row items-center gap-8">
        <div 
        onClick={(e)=>{
          e.stopPropagation()
          handleplay(card.audiolink);

        }}
        className="cursor-pointer">
            <FontAwesomeIcon icon={faPlay} className="text-[#94A3B8] w-5 h-5 mb-[3px]"/>
        </div>
    
   {(() => {
  if (card?.transcriptionstatus === 'Processing') {
    return (<>
  
      { renderStatus(card)}</>
    );
  } else if (card?.transcriptionstatus === 'Summarized') {
    return (
      <div className="w-7 h-7">
       <Tooltip title="Pending Review"><img onClick={(e)=>{
              e.stopPropagation();
              setModalValue({selectedRecord :card})  
              setModalValue({ screen :1}) 
              if (!location.pathname.startsWith('/v2')) {
                navigate('/v2', { state: { back: true } });
              }
          }} src={summarizedpng} alt="pending review" className="w-6 h-6" /></Tooltip>
      </div>
    );
  } else if (card?.transcriptionstatus === 'APPROVED') {
    return (
      <div className="w-7 h-7">
       <Tooltip title="Completed"><img src={checkmark} alt="Completed" className="w-6 h-6" /></Tooltip>
      </div>
    );
  } else {
    return null; // Optional: handle cases where no condition matches
  }
})()}

<div onClick={(e)=>{
  e.stopPropagation()
  setClicked(card)
  setDeletemodal(true)
}}>

<FontAwesomeIcon icon={faTrash} className="text-red-600   mb-[3px]"/>
</div>
      </div>
   




    </div>
  ))
) : (
  <div>No data found</div>
)}

          </div>
        {currentData && currentData.length > 0? <div className="flex w-full items-center justify-center"> <div onClick={handlePreviousPage} disabled={currentPage === 1}><NavigateBeforeIcon/></div> 
          {currentPage}/{totalPages}
          
           <div onClick={handleNextPage} disabled={currentPage === totalPages}><NavigateNext/></div></div>:<></>}
          
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading||loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SimpleModal isModalOpen={showinfo} setModalOpen={setShowInfo} data={currentobj}/>
        <DeleteRecord isModalOpen={deletemodal} setIsDeleteModal={setDeletemodal} text={clicked} handledelete={handleDeleteRecord} />
      <ToastMessage
                open={open}
                message={message}
                severity={severity}
                handleClose={handleClose}
            />
            <PromptModal isModalOpen={promptmodal} setModalOpen={setPromptModal} data={currentobj}/>
      <BasicPdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
      <AudioModal
        open={isModalOpen}
        onClose={handleCloseModal}
        audioSrc={audioSrc}
        loading={loading}
      />
      </div>
    </>
  );
};

export default BasicArchive;
